import { storageProvider } from '@ocean/configs'

const HIGHLIGHTED_NOTIFICATIONS_VIEWED = 'HIGHLIGHTED_NOTIFICATIONS_VIEWED'

// Highlighted Notifications for page refresh and direct links
class HighlightedNotificationsUtils {
  viewed = 'VIEWED'

  markHighlightedNotificationsViewed() {
    storageProvider.setItem(HIGHLIGHTED_NOTIFICATIONS_VIEWED, this.viewed)
  }

  clearHighlightedNotificationsViewed() {
    storageProvider.removeItem(HIGHLIGHTED_NOTIFICATIONS_VIEWED)
  }

  getHighlightedNotificationsState() {
    return storageProvider.getItem(HIGHLIGHTED_NOTIFICATIONS_VIEWED)
  }
}

export default new HighlightedNotificationsUtils()
